<template>
  <div class="content-container">
    <div v-if="!appFetchingError" class="apps-container">
      <v-card v-for="c in contents" :key="c.uuid" :app="c"></v-card>
    </div>
  </div>
</template>

<script>
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import VCard from "@/components/VCard";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "AppsList",
    data() {
      return {
        appFetchingError: null
      };
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      contents() {
        return this.apps.filter(a => !a.isTemplate);
      }
    },
    mounted() {
      const info = this.$route.params.dataFetchingInfo;
      if (info && info.isFailed) {
        this.appFetchingError = info.isFailed;
        this.$bvToast.toast(
          this.getMessageText(this.messages.FAILED_TO_LOAD_CONTENT_LIST),
          TOAST_OPTIONS.bottomCenter
        );
      }
      // reset configuration and preview options for pages tab
      this.setPageInfo({});
    },
    components: { VCard },
    methods: {
      ...mapActions({
        setPageInfo: MUTATION_NAME.SET_PAGE_INFO
      })
    }
  };
</script>

<style scoped>
  .content-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 1rem;
  }

  .apps-container {
    display: flex;
    flex-wrap: wrap;
  }
</style>
